import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots';

const json = {

  1: { // Exercise num
    unit: 'Unit 4',
    id: 'WB3-U4-P31-E1',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page31/E1/Key/answerKey.png',
    component: MatchDots,
    // titleQuestion: [{ num: '1', title: 'Listen and draw lines.', color: "#5B5A5D" }],
    question: {
      DrawLines: {
        multipleLine: true,
        boxMatch: [

          { boxMatchStyle: { position: 'absolute', top: '108px', left: '362px', width: 167, height: 63, borderRadius: '50px', transform: 'rotate(-15deg)' } }, //bl 1
          { boxMatchStyle: { position: 'absolute', top: '217px', left: '509px', width: 160, height: 52, borderRadius: '50px', transform: 'rotate(-7deg)' } }, //bl 2
          { boxMatchStyle: { position: 'absolute', top: '269px', left: '585px', width: 163, height: 52, borderRadius: '50px', transform: 'rotate(-11deg)' } }, //bl 3
          { boxMatchStyle: { position: 'absolute', top: '248px', left: '854px', width: 168, height: 121, borderRadius: '50%' } }, //blanket (2)

          { boxMatchStyle: { position: 'absolute', top: '208px', left: '172px', width: 160, height: 54, borderRadius: '50px', transform: 'rotate(21deg)' } }, //fl 1
          { boxMatchStyle: { position: 'absolute', top: '376px', left: '295px', width: 152, height: 42, borderRadius: '50px', transform: 'rotate(5deg)' } }, //fl 2
          { boxMatchStyle: { position: 'absolute', top: '330px', left: '409px', width: 174, height: 49, borderRadius: '50px', transform: 'rotate(8deg)' } }, //fl 3
          { boxMatchStyle: { position: 'absolute', top: '373px', left: '577px', width: 174, height: 56, borderRadius: '50px', transform: 'rotate(-2deg)' } }, //fl 4
          { boxMatchStyle: { position: 'absolute', top: '376px', left: '854px', width: 168, height: 121, borderRadius: '50%' } }, //flower (3)



          { boxMatchStyle: { position: 'absolute', top: '325px', left: '184px', width: 157, height: 45, borderRadius: '50px', transform: 'rotate(-11deg)' } }, //pl 1
          { boxMatchStyle: { position: 'absolute', top: '208px', left: '336px', width: 162, height: 55, borderRadius: '50px', transform: 'rotate(6deg)' } }, //pl 2
          { boxMatchStyle: { position: 'absolute', top: '170px', left: '605px', width: 173, height: 58, borderRadius: '50px' } }, //pl 3
          { boxMatchStyle: { position: 'absolute', top: '78px', left: '594px', width: 163, height: 58, borderRadius: '50px', transform: 'rotate(16deg)' } }, //pl 4
          { boxMatchStyle: { position: 'absolute', top: '118px', left: '854px', width: 168, height: 121, borderRadius: '50%' } }, //flower (1)
        ],
        answers: ['0-1', '1-2', '2-3', '4-5', '5-6', '6-7', '7-8', '10-9', '10-11', '11-12', '12-13'],
        initialValue: [],
      },
      Layout: `
          <img src='img/FriendsPlus/Page31/E1/1.jpg' />
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />
          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />
          <input id='5' type= 'boxMatch' />
          <input id='6' type= 'boxMatch' />
          <input id='7' type= 'boxMatch' />
          <input id='8' type= 'boxMatch' />
          <input id='9' type= 'boxMatch' />
          <input id='10' type= 'boxMatch' />
          <input id='11' type= 'boxMatch' />
          <input id='12' type= 'boxMatch' />
          <input id='13' type= 'boxMatch' />
      `,
    },
  },
  2: { // Exercise num
    unit: 'Unit 4',
    id: 'WB3-U4-P31-E2',
    audio: '',
    video: '',
    component: DesignUnderLine,
    // component: DesignUnderLine1,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page31/E2/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page31/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page31/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page31/E2/3.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page31/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page31/E2/5.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page31/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page31/E2/7.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page31/E2/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page31/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page31/E2/10.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page31/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page31/E2/12.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page31/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page31/E2/14.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page31/E2/15.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page31/E2/16.jpg' },
        { url: 'img/FriendsPlus/Page31/E2/17.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page31/E2/18.jpg' },
        { url: 'img/FriendsPlus/Page31/E2/19.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page31/E2/20.jpg' },
        { url: 'img/FriendsPlus/Page31/E2/21.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page31/E2/22.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page31/E2/23.jpg' },
      ],
    ]
  },
  3: { // Exercise num
    unit: 'Unit 4',
    id: 'WB3-U4-P31-E3',
    audio: 'img/FriendsPlus/Page31/Audio/audio-e3-p31.mp3',
    video: '',
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page31/E3/Key/answerKey.png',
    component: D1,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page31/E3/1.jpg' },
        { url: 'img/FriendsPlus/Page31/E3/2.jpg', audioUrl: 'img/FriendsPlus/Page31/Audio/tieude-e3-p31.mp3' },
        { url: 'img/FriendsPlus/Page31/E3/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page31/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page31/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page31/E3/6.jpg', input: true, answer: "Plums" },
        { url: 'img/FriendsPlus/Page31/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page31/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page31/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page31/E3/10.jpg', input: true, answer: "plate" },
        { url: 'img/FriendsPlus/Page31/E3/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page31/E3/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page31/E3/13.jpg' },
        { url: 'img/FriendsPlus/Page31/E3/14.jpg', input: true, answer: "blanket" },
        { url: 'img/FriendsPlus/Page31/E3/15.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page31/E3/16.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page31/E3/17.jpg' },
        { url: 'img/FriendsPlus/Page31/E3/18.jpg', input: true, answer: "flower" },
        { url: 'img/FriendsPlus/Page31/E3/19.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page31/E3/20.jpg' },
      ],


    ]
  },



}

export default json;